import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import {OrderStatusPageContext} from "@MasterBluePrint/Overrides/Pages/OrderStatusPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";


export interface OrderDetailsShippingAddressStyles {
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;
export const shippingAddressStyles: OrderDetailsShippingAddressStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;

            address {
                color: ${themeColors.colorCharcoalGrey};
                font-family: 'Lato',sans-serif;
                font-size: ${themeFontSizes.size14};
                letter-spacing: 0.44px;
                line-height: 1.5rem;
                margin-top: 15px;

                p {
                    color: ${themeColors.colorCharcoalGrey};
                    font-family: 'Lato',sans-serif;
                    font-size: ${themeFontSizes.size14};
                    letter-spacing: 0.44px;
                }
            }
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .31250625rem;
            color: #002554;
            font-family: Roboto;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 23px;
        `,
    },
};

const styles = shippingAddressStyles;

const OrderDetailsShippingAddress: FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);
    if (!order && !orderData) {
        return null;
    }

    const hasShippingAddress = order?.fulfillmentMethod === FulfillmentMethod.Ship || !order?.fulfillmentMethod;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate(hasShippingAddress ? "Shipping Information" : "Pick Up Location")}</Typography>

            <AddressInfoDisplay
                firstName={order?.properties.stFirstName ?? orderData?.properties.stFirstName}
                lastName={order?.properties.stLastName ??orderData?.properties.stLastName}
                companyName={order?.stCompanyName??orderData?.stCompanyName}
                address1={order?.stAddress1??orderData?.stAddress1??""}
                address2={order?.stAddress2??orderData?.stAddress2}
                address3={order?.stAddress3??orderData?.stAddress3}
                address4={order?.stAddress4??orderData?.stAddress4}
                city={order?.shipToCity?? orderData?.shipToCity??""}
                state={order?.shipToState??orderData?.shipToState}
                postalCode={order?.shipToPostalCode??orderData?.shipToPostalCode??""}
                country={order?.stCountry??orderData?.stCountry}
                extendedStyles={styles.addressDisplay}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDetailsShippingAddress),
    definition: {
        allowedContexts: [OrderDetailsPageContext,OrderStatusPageContext,"RfqQuoteDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;